module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pers-topic",
      "name": "hres31x-topic"
    }
  }, [_c('div', {
    staticClass: "main-topic-box"
  }, [_c('i', {
    staticClass: "left-arrow fa fa-angle-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onArrowLeft()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-topic",
    on: {
      "click": function($event) {
        _vm.toggleMenuMobile()
      }
    }
  }, [_vm._v(_vm._s(_vm.nameTopic(_vm.page)))]), _vm._v(" "), _c('i', {
    staticClass: "right-arrow fa fa-angle-right",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.onArrowRight()
      }
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0a4aafdb!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres31x/topic.vue
// module id = 3532
// module chunks = 1